import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { MailWriteDTO } from '../interfaces/mail';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private dataService: DataService) { }

  sendMail(mail: MailWriteDTO) {
    return this.dataService.sendMail(mail);
  }
}
